export enum PortType {
	None = 0,
	Left = 1,
	Right = 2,
	Under = 3
}